import { render, staticRenderFns } from "./mycheck.vue?vue&type=template&id=b107d718&scoped=true"
import script from "./mycheck.vue?vue&type=script&lang=js"
export * from "./mycheck.vue?vue&type=script&lang=js"
import style0 from "./mycheck.vue?vue&type=style&index=0&id=b107d718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b107d718",
  null
  
)

export default component.exports